import { CANCEL_REASONS, PASCAL_TO_SNAKE } from 'Utils/IntakeAdmin/Constants';
import {
    ALL_APPOINTMENT_STATUSES,
    APPOINTMENT_QUICK_CHANGE_STATUSES,
} from 'Utils/IntakeAdmin/Constants';

/** Re-export for PDP header / filters (same order as quick-change menu). */
export const APPOINTMENT_STATUS_QUICK_MENU_ORDER = APPOINTMENT_QUICK_CHANGE_STATUSES;

/** Terminal: cannot change away via quick menu without reschedule flow. */
export const TERMINAL_APPOINTMENT_STATUSES = Object.freeze(['completed', 'no_show', 'late_cancelled']);



const KNOWN = new Set([...ALL_APPOINTMENT_STATUSES, 'booked', 'checked_in']);

export const normalizeAppointmentStatus = (raw) => {
    if (raw == null || raw === '') return 'scheduled';
    const s = String(raw).trim();
    if (PASCAL_TO_SNAKE[s]) return PASCAL_TO_SNAKE[s];
    const spaced = s.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
    const underscored = spaced.replace(/\s+/g, '_').toLowerCase();
    if (KNOWN.has(underscored)) return underscored;
    const lc = s.toLowerCase().replace(/\s+/g, '_');
    if (lc === 'noshow' || lc === 'no-show') return 'no_show';
    if (KNOWN.has(lc)) return lc;
    return underscored || 'scheduled';
};

/** Labels + dot colors for dropdown rows, toasts, and modal copy. */
export const APPOINTMENT_STATUS = {
    requested: { label: 'Requested', dotColor: 'bg-slate-500' },
    waitlisted: { label: 'Waitlisted', dotColor: 'bg-purple-500' },
    scheduled: { label: 'Scheduled', dotColor: 'bg-blue-500' },
    confirmed: { label: 'Confirmed', dotColor: 'bg-green-500' },
    completed: { label: 'Completed', dotColor: 'bg-emerald-600' },
    cancelled: { label: 'Cancelled', dotColor: 'bg-red-500' },
    late_cancelled: { label: 'Late cancelled', dotColor: 'bg-rose-600' },
    no_show: { label: 'No show', dotColor: 'bg-amber-500' },
    rescheduled: { label: 'Rescheduled', dotColor: 'bg-violet-500' },
    booked: { label: 'Booked', dotColor: 'bg-blue-500' },
    checked_in: { label: 'Checked in', dotColor: 'bg-emerald-500' },
};

export const REASONS_BY_STATUS = {
    cancelled: [...CANCEL_REASONS],
    late_cancelled: [...CANCEL_REASONS],
    no_show: ['Patient no-show', 'Clinic / schedule issue', 'Weather / emergency', 'Other'],
};


export const statusRequiresReason = (effectiveSnake) => {
    return ['cancelled', 'late_cancelled', 'no_show'].includes(effectiveSnake);
}

export const LATE_CANCEL_WINDOW_MS = 24 * 3600 * 1000;

export const mapAppointmentStatusToApi = (status) => {
    const map = {
        scheduled: 'Scheduled',
        confirmed: 'Confirmed',
        completed: 'Completed',
        cancelled: 'Cancelled',
        no_show: 'NoShow',
        rescheduled: 'Rescheduled',
        requested: 'Requested',
        waitlisted: 'Waitlisted',
        late_cancelled: 'LateCancelled',
        booked: 'Booked',
        checked_in: 'CheckedIn',
    };
    return map[status] ?? status;
};
